import socket from '../Core/socketConnect.js';

const clientUserFullGid = data_handler.clientUserFullGid,
	ajaxurl = data_handler.ajaxurl;

const DOMElements = {
	userJoinGroupIdInput: '#user-join-group-id-input',
	userJoinGroupButton: '#user-join-group-button',
	teamMembersOv: '#team-members-overview',
};

const userJoinGroupIdInput = document.querySelector(
		DOMElements.userJoinGroupIdInput
	),
	userJoinGroupButton = document.querySelector(
		DOMElements.userJoinGroupButton
	),
	teamMembersOv = document.querySelector(DOMElements.teamMembersOv);

const updateMembersListAjax = (gid) => {
	const request = new XMLHttpRequest();
	request.open('POST', ajaxurl, true);
	request.setRequestHeader(
		'Content-Type',
		'application/x-www-form-urlencoded;'
	);
	request.setRequestHeader('Access-Control-Allow-Headers', '*');
	request.onreadystatechange = function () {
		if (this.readyState === 4 && this.status === 200) {
			updateMembersList(this.response);
		}
	};
	request.send('action=load_members_list_ajax&gid=' + gid);
};

const updateMembersList = (membersList) => {
	const members = JSON.parse(membersList);
	if (teamMembersOv) {
		teamMembersOv.innerHTML = '';
		members.forEach((element) => {
			teamMembersOv.insertAdjacentHTML(
				'beforeend',
				'<div class="member ani scale centerSpaceBetween triggeredCSS3"><div>' +
					element +
					'</div><div class="online"></div></div>'
			);
		});
	}
};

const updateTeamView = () => {
	const enteredGid = userJoinGroupIdInput.value;
	socketEmitUserJoin(enteredGid);
};

const socketEmitUserJoin = (gid) => {
	socket.emit('user-join', {
		gid,
	});
};

const UserJoinGroupAction = {
	bindEvents: () => {
		if (userJoinGroupButton) {
			userJoinGroupButton.addEventListener('click', updateTeamView);
		}
	},
	userJoinGroupSocketListener: () => {
		socket.on('user-join', function (data) {
			if (data.data.gid === clientUserFullGid) {
				updateMembersListAjax(clientUserFullGid);
			}
		});
	},
};

export default UserJoinGroupAction;
